export default __webpack_public_path__ + "static/media/i053vp.9798d1af.webp";